import type { Moment } from 'moment';
import moment from 'moment';

export const generateRangeMomentArray = (
  startDate: Date | Moment,
  endDate: Date | Moment,
): string[] => {
  if (!startDate || !endDate) {
    return [];
  }
  const dateArray: string[] = [];
  const currentDate = moment(startDate);
  const finalDate = moment(endDate);

  while (currentDate.isSameOrBefore(finalDate)) {
    const a = currentDate.format('DD/MM/YYYY');
    dateArray.push(a);
    currentDate.add(1, 'days');
  }

  return dateArray;
};
